import React from "react";
import StoriLogo from "./StoriLogo";
import { Linkedin, Instagram, Youtube, Twitter } from "lucide-react";

const COLS = [
  {
    title: "Products",
    links: ["Stori HALO (hardware)", "Stori Software", "AI Capabilities", "Pricing"],
  },
  {
    title: "Use Cases",
    links: ["Event Activations", "Permanent Installations", "Lead Generation", "By Industry"],
  },
  {
    title: "Resources",
    links: ["Blog", "Case Studies", "Documentation", "API Docs"],
  },
  {
    title: "Company",
    links: ["About", "Careers", "Press", "Contact"],
  },
];

const LEGAL = ["Privacy", "Terms", "GDPR", "Accessibility"];

const SOCIAL = [
  { Icon: Linkedin, href: "#", label: "LinkedIn" },
  { Icon: Instagram, href: "#", label: "Instagram" },
  { Icon: Youtube, href: "#", label: "YouTube" },
  { Icon: Twitter, href: "#", label: "Twitter" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-stori-bg pt-20 pb-10">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 pb-14 border-b border-stori-border">
          <div className="lg:col-span-4">
            <StoriLogo className="h-10 w-auto" />
            <p className="mt-6 text-stori-muted text-sm leading-relaxed max-w-xs">
              Experimental media platform turning guest moments into measurable outcomes.
              Made in Los Angeles · Est. 2014.
            </p>

            {/* Made by — AI Dept. */}
            <div className="mt-7 flex items-center gap-3" data-testid="made-by">
              <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-stori-muted">
                Made by:
              </span>
              <a
                href="#"
                aria-label="The AI Dept."
                data-testid="made-by-logo-link"
                className="inline-flex items-center hover:opacity-80 transition-opacity"
              >
                <img
                  src="https://customer-assets.emergentagent.com/job_guest-intelligence/artifacts/ly7h65qc_ai-dept-logo.png"
                  alt="The AI Dept."
                  className="h-7 w-auto"
                  loading="lazy"
                />
              </a>
            </div>

            <div className="mt-6 flex items-center gap-3">
              {SOCIAL.map(({ Icon, href, label }) => (
                <a
                  key={label}
                  href={href}
                  aria-label={label}
                  data-testid={`social-${label.toLowerCase()}`}
                  className="w-9 h-9 rounded-md border border-stori-border flex items-center justify-center text-stori-muted hover:text-stori-cyan hover:border-stori-cyan transition-colors"
                >
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-8 grid grid-cols-2 md:grid-cols-4 gap-8">
            {COLS.map((c) => (
              <div key={c.title}>
                <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-stori-cyan">
                  {c.title}
                </div>
                <ul className="mt-5 space-y-3">
                  {c.links.map((l) => (
                    <li key={l}>
                      <a
                        href="#"
                        className="text-sm text-stori-muted hover:text-white transition-colors"
                      >
                        {l}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="pt-8 flex flex-wrap items-center justify-between gap-4">
          <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-stori-muted">
            © {new Date().getFullYear()} Stori, Inc · All rights reserved
          </div>
          <div className="flex flex-wrap gap-x-6 gap-y-2">
            {LEGAL.map((l) => (
              <a
                key={l}
                href="#"
                data-testid={`legal-${l.toLowerCase()}`}
                className="font-mono text-[10px] uppercase tracking-[0.2em] text-stori-muted hover:text-white transition-colors"
              >
                {l}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
